import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const Footer = () => (
  <footer className="footer">
    <Container fluid>
      <Row>
        <Col sm={6}>
          <div className="text-sm-left d-none d-sm-block">
            {new Date().getFullYear()}
            {' '}
            © Ecossis Soluções Ambientais
          </div>
        </Col>
        <Col sm={6}>
          <div className="text-sm-right d-none d-sm-block">
            Oikos v1.0.0
          </div>
        </Col>
      </Row>
    </Container>
  </footer>
)

export default Footer
